import React, { useEffect, useState } from 'react'
import { Alert, Button, Group, Text } from '@mantine/core'
import { ClockIcon, ExclamationTriangleIcon } from '@radix-ui/react-icons'

import { WeeklyAvailabilityModal } from './WeeklyAvailabilityModal'
import { getWeekStart } from './weekUtils'

import { useReporter } from '@/providers/UserProvider'
import { useCalendarParams } from '@/queries/useCalendarParams'
import { useWeeklyAvailabilityQuery } from '@/queries/weeklyAvailability'

export const WeeklyAvailabilityBanner: React.FC = () => {
  const reporter = useReporter()
  const calendarParams = useCalendarParams()
  const [isOpen, setIsOpen] = useState(false)

  const weekStart = calendarParams ? getWeekStart(calendarParams.date) : null

  const { data: response } = useWeeklyAvailabilityQuery(
    reporter?.id ?? '',
    weekStart ?? new Date(),
    {
      enabled: !!reporter && !!weekStart && calendarParams?.view === 'week',
    },
  )

  const data = response?.data
  const shouldShowBanner =
    !!reporter &&
    !!weekStart &&
    calendarParams?.view === 'week' &&
    !!data &&
    !data.is_read_only &&
    (data.ranges ?? []).length === 0 &&
    !data.last_updated_at

  useEffect(() => {
    if (!shouldShowBanner) {
      setIsOpen(false)
    }
  }, [shouldShowBanner])

  if (!shouldShowBanner) {
    return null
  }

  return (
    <>
      <Alert
        color="yellow"
        icon={<ExclamationTriangleIcon />}
        className="mx-4 mt-4 mb-6"
        styles={{ message: { width: '100%' } }}
      >
        <Group position="apart" noWrap className="w-full">
          <Text size="sm">No availability set for this week</Text>
          <Button
            size="xs"
            variant="white"
            leftIcon={<ClockIcon />}
            onClick={() => setIsOpen(true)}
          >
            Set availability
          </Button>
        </Group>
      </Alert>
      {isOpen && (
        <WeeklyAvailabilityModal
          reporterId={reporter.id}
          reporterTimezone={reporter.timezone ?? null}
          initialWeekStart={weekStart}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  )
}
